import adapter from '../adapter-blog-post';
import { siteIDs } from '../../../adapters/utils';
var IDs = adapter.IDs, SchemaTypes = adapter.SchemaTypes;
export default {
    type: SchemaTypes.BLOG_POST_BLOG_POSTING,
    schema: {
        '@context': 'https://schema.org',
        '@type': 'BlogPosting',
        author: {
            '@type': 'Person',
            name: "{{" + IDs.AUTHOR + "}}",
            image: {
                '@type': 'ImageObject',
                url: "{{" + IDs.AUTHOR_IMAGE_URL + "}}",
                width: "{{" + IDs.AUTHOR_IMAGE_WIDTH + "}}",
                height: "{{" + IDs.AUTHOR_IMAGE_HEIGHT + "}}",
            },
        },
        articleSection: "{{" + IDs.CATEGORIES + "}}",
        dateModified: "{{" + IDs.LAST_MODIFIED_DATE + "}}",
        datePublished: "{{" + IDs.PUBLISH_DATE + "}}",
        headline: "{{" + IDs.HEADLINE + "}}",
        mainEntityOfPage: {
            '@id': "{{" + IDs.POST_PAGE_URL + "}}",
            '@type': 'itemPage',
            url: "{{" + IDs.POST_PAGE_URL + "}}",
        },
        description: "{{" + IDs.DESCRIPTION + "}}",
        url: "{{" + IDs.POST_PAGE_URL + "}}",
        image: {
            '@type': 'ImageObject',
            url: "{{" + IDs.COVER_IMAGE + "}}",
            width: "{{" + IDs.COVER_IMAGE_WIDTH + "}}",
            height: "{{" + IDs.COVER_IMAGE_HEIGHT + "}}",
        },
        publisher: {
            '@type': 'Organization',
            name: "{{" + siteIDs.SITE_NAME + "}}",
            logo: {
                '@type': 'ImageObject',
                url: "{{" + siteIDs.BUSINESS_LOGO + "}}",
            },
        },
    },
    disabled: "{{" + IDs.SD_DISABLE_SCHEMA + "}",
};
